
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.5 5a.5.5 0 00-.5.5v3a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-7a.5.5 0 01.5-.5h3a.5.5 0 100-1h-3A1.5 1.5 0 000 1.5v7A1.5 1.5 0 001.5 10h7A1.5 1.5 0 0010 8.5v-3a.5.5 0 00-.5-.5zM2 5.38V7.5a.5.5 0 00.5.5h2.12a.5.5 0 00.355-.145l3.46-3.465L9.855 3a.5.5 0 000-.71L7.735.145a.5.5 0 00-.71 0L5.615 1.56l-3.47 3.465A.5.5 0 002 5.38zm5.38-4.175L8.795 2.62l-.71.71L6.67 1.915l.71-.71zM3 5.585L5.965 2.62 7.38 4.035 4.415 7H3V5.585z","fill":"#DEDEDE"}})])
          )
        }
      }
    